import React, { Component } from 'react'
import _ from 'lodash'
import liffHelper from '../utils/liffHelper'
import utils from '../utils/utils'
import { Card, Button, CardHeader, CardFooter, CardBody,
  CardTitle, CardText, Form, FormGroup, Label, Input, FormText } from 'reactstrap'

const liff = liffHelper.getLiff()

export default class LIFFWindow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      login_user: {
        name: "",
        email: "",
        phone: ""
      },
      salesiq_ready: false,
      login: false,
    }

    // widget code來源
    // sites673991192 7bc268dc7cf3471744a38121eef448734f30f7472b1ccfd7360951b981d026c868409cad85ff645e864c60b52c277087
    // 康 widgetCode de883af2db8fc3407ccf2b69671fbb5837876ad46a71d9ee878eb085fb0de10c
    // 測試用 ce-backend 473720d2d0e4aecaea28a1ffd290c34056a838d7003e9fafb33371b02d590d1e
    let widgetCode = "473720d2d0e4aecaea28a1ffd290c34056a838d7003e9fafb33371b02d590d1e"

    this.initSalesIQ(widgetCode)

    // 要再寫一個純js版的測試initSalesIQ的改變
  }

  initSalesIQ (widgetCode) {
    const that = this

    var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode:widgetCode, values:{},ready:function(){
      // sales_iq 載入完成後要做的事情
      console.log("準備好囉123")
      that.setState({ salesiq_ready: true })

      // 預設聊天室窗活動 (展開 show/隱藏 hide)
      $zoho.salesiq.floatwindow.visible("show")
    }}
    window.$zoho = $zoho
    var d=document
    var s=d.createElement("script")
    s.type="text/javascript"
    s.id="zsiqscript"
    s.defer=true
    s.src="https://salesiq.zoho.com/widget"
    // var t=d.getElementsByTagName("script")[0]
    // t.parentNode.insertBefore(s,t)
    document.body.appendChild(s)
    // d.write("<div id='zsiqwidget'></div>")
    var divEle = document.createElement('div')
    divEle.id = "zsiqwidget"
    document.body.append(divEle)
  }

  async componentDidMount() {
  }

  async componentDidUpdate(prevProps, prevState) {
    const salesiq_ready = prevState.salesiq_ready !== this.state.salesiq_ready && this.state.salesiq_ready === true
    const login = prevState.login !== this.state.login && this.state.login === true

    if (login) {
      const { login_user } = this.state

      let $zoho = window.$zoho
      $zoho.salesiq.visitor.name(login_user.name)
      $zoho.salesiq.visitor.email(login_user.email)
      $zoho.salesiq.visitor.contactnumber(login_user.phone)
      //$zoho.salesiq.chatbutton.texts([["online時上排訊息1234", "online時下排訊息"], ["offline時上排訊息", "offline時上排訊息"]])
      //$zoho.salesiq.visitor.question("123124");
      //$zoho.salesiq.chat.start();
    }
  }

  clickLogin = (e) => {
    const { login_user } = this.state
    if(login_user.name === "" || login_user.email === "" || login_user.phone === "")  return window.alert("登入資料未齊全, 請完整輸入後重試")

    this.setState({ login: true })
  }

  render() {
    return (
      <React.Fragment>
        <header className="app-header">
          <h3 className="app-title">客服線上交談</h3>
        </header>

        <div className="container" style={{ "text-align": "left" }}>
          <br />
          <div className="row">
            <div className="col" />
            <div className="col-lg-4">
              <Card>
                <CardHeader>登入資料模擬</CardHeader>
                <CardBody>
                  <Form>
                    <FormGroup>
                      <Label>name</Label>
                      <Input disabled={this.state.login} type="text" placeholder=""
                        onChange={(e) => {
                          const { login_user } = this.state
                          login_user.name = e.target.value
                          this.setState({ login_user })
                        }}
                        value={this.state.login_user.name}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>email</Label>
                      <Input disabled={this.state.login} type="email" placeholder=""
                        onChange={(e) => {
                          const { login_user } = this.state
                          login_user.email = e.target.value
                          this.setState({ login_user })
                        }}
                        value={this.state.login_user.email}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>phone</Label>
                      <Input disabled={this.state.login} type="number" placeholder=""
                        onChange={(e) => {
                          const { login_user } = this.state
                          login_user.phone = e.target.value
                          this.setState({ login_user })
                        }}
                        value={this.state.login_user.phone}
                      />
                    </FormGroup>

                    <hr />
                    <Button disabled={!this.state.salesiq_ready || this.state.login} color={ !this.state.login ? "primary" : "secondary"} size="md" block
                      onClick={this.clickLogin}
                    >
                      {
                        this.state.login ?
                        "已登入" : "登入"
                      }
                    </Button>

                  </Form>

                </CardBody>
              </Card>
            </div>
            <div className="col" />

          </div>
        </div>

      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/SalesIQProjectDataSample.js